module.exports = __webpack_public_path__ + "static/media/sow-section-3-parents.2b136b2f.svg";